import React from 'react';
import { PHONE_FRAME_HEIGHT } from '../constants';

const PreviewFrame = ({ 
  sandboxHost, 
  isDesktopView, 
  scale, 
  viewportWidth,
  scaledHeight,
  onError, 
  iframeRef 
}) => {
  return (
    <div 
      className={isDesktopView ? "absolute top-0 left-0" : "absolute inset-0 flex items-center justify-center"}
      style={isDesktopView ? {
        width: `${viewportWidth}px`,
        height: scaledHeight,
        transform: `scale(${scale})`,
        transformOrigin: 'top left'
      } : {
        transform: `scale(${scale})`,
        transformOrigin: 'center',
        zIndex: 10
      }}
    >
      <div
        className="relative"
        style={isDesktopView ? {
          width: '100%',
          height: '100%'
        } : {
          position: 'relative',
          width: `${viewportWidth}px`,
          height: `${PHONE_FRAME_HEIGHT - 24}px`, // Account for padding (p-3 = 12px * 2)
          overflow: 'hidden',
          borderRadius: '2rem'
        }}
      >
        <iframe
          src={`https://${sandboxHost}`}
          className="border-0"
          style={{ 
            width: `${viewportWidth}px`, 
            height: isDesktopView ? '100%' : `${PHONE_FRAME_HEIGHT - 24}px`, // Fill available space
            display: 'block'
          }}
          title="Application Preview"
          sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-modals"
          allow="clipboard-write; clipboard-read"
          ref={iframeRef}
          onError={onError}
        />
      </div>
    </div>
  );
};

export default PreviewFrame; 